import { render, staticRenderFns } from "./StepProtectionOrder.vue?vue&type=template&id=655eabdb"
import script from "./StepProtectionOrder.vue?vue&type=script&lang=ts"
export * from "./StepProtectionOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports